"use client";

import { cva, type VariantProps } from "cva";
import { InfoIcon } from "lucide-react";
import { cn } from "#ui-atoms/lib/utils";
import { BaseFieldError, type BaseFieldErrorProps } from "./field-error";

const conEdisonFieldErrorVariants = cva({
  base: [
    "absolute top-2.5 w-full min-w-[150%] translate-x-[-16.5%] text-center text-sm font-semibold leading-[1.135] text-tenant-con-edison-website-destructive @[16rem]/form-item:min-w-fit @[16rem]/form-item:translate-x-0",
    "data-invalid-border-website-destructive",
  ],
  variants: {
    variant: {
      default: "",
      centered: { true: "items-center", false: undefined },
      card: "", // unused for con edison
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

type ConEdisonFieldErrorVariant = VariantProps<
  typeof conEdisonFieldErrorVariants
>["variant"];

export interface ConEdisonFieldErrorProps
  extends Omit<BaseFieldErrorProps, "variant"> {
  variant?: ConEdisonFieldErrorVariant;
  icon?: React.ReactNode;
}

export default function ConEdisonFieldError({
  className,
  variant,
  icon,
  ...props
}: ConEdisonFieldErrorProps) {
  const displayIcon = icon ?? <InfoIcon className="mr-1 inline size-3.5" />;

  // const { error } = useFormField();

  // const body = error
  //   ? t(String(error.message), {
  //       defaultValue: String(error.message),
  //     })
  //   : children;

  // const showMessage = !!body;
  const showMessage = true; // TODO: remove this

  const content = showMessage ? (
    <BaseFieldError
      className={cn(
        conEdisonFieldErrorVariants({
          variant,
          className,
        }),
        className,
      )}
      // id={formMessageId}
      // ref={ref}
      {...props}
    >
      {displayIcon}
      {/* {body} */}
    </BaseFieldError>
  ) : null;

  return (
    /* status bar (+ floating error message) */
    <div
      className={cn(
        "relative border-tenant-con-edison-website-border border-b-[0.125rem]",
        {
          // "border-tenant-con-edison-website-green": isDirty && !error,
        },
      )}
    >
      {content}
    </div>
  );
}
